import type { ReactNode, ReactElement } from 'react';

import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';

import HeaderDropDownTitle from './HeaderDropDownTitle';
import HeaderDropDownItem from './HeaderDropDownItem';

interface Props {
  name: string;
  title: ReactNode;
  items: ReactElement[];
}

const Root = styled(ContentWrapper)(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: spacing(4),
  paddingBottom: spacing(6),
  gap: spacing(8),
}));

const ItemsContainer = styled('div')(({ theme: { spacing } }) => ({
  display: 'flex',
  gap: spacing(4),
}));

const Item = styled('div')(({ theme: { palette, spacing } }) => ({
  position: 'relative',
  '&:not(:first-of-type)::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: spacing(-2),
    display: 'block',
    width: 1,
    backgroundColor: palette.layout.line.divider,
  },
}));

export default function HeaderDropDown({ title, items, name }: Props) {
  return (
    <Root id={`header-submenu-${name}`}>
      <div>{title}</div>
      <div>
        <ItemsContainer>
          {items.map((item, n) => (
            <Item key={item.props?.title ?? n}>{item}</Item>
          ))}
        </ItemsContainer>
      </div>
    </Root>
  );
}

HeaderDropDown.Title = HeaderDropDownTitle;
HeaderDropDown.Item = HeaderDropDownItem;
